import { ExportStatus } from 'app/area/my-downloads/exports/exports-view/types-store';

export const ACTION = {
  REQUEST_EXPORT_CASES: 'EXPORTS_MODAL:REQUEST_EXPORT_CASES',
  RECEIVE_EXPORT_CASES: 'EXPORTS_MODAL:RECEIVE_EXPORT_CASES',
  FAIL_EXPORT_CASES: 'EXPORTS_MODAL:FAIL_EXPORT_CASES'
};

export class RequestExportCases {
  public type: string = ACTION.REQUEST_EXPORT_CASES;
}

export class ReceiveExportCases {
  public type: string = ACTION.RECEIVE_EXPORT_CASES;
  public exportStatus: ExportStatus[];

  constructor(exportStatus: ExportStatus[]) {
    this.exportStatus = exportStatus;
  }
}

export class FailExportCases {
  public type: string = ACTION.FAIL_EXPORT_CASES;
}
